module.exports = __webpack_public_path__ + "media/application/images/2024/title-3000-ab06f988e3a9b4a26193742b126ab37b.png";